export default function isMobileDevice() {
  return /Mobile|Android|iPhone|iPad/i.test(navigator.userAgent);
}
